import { render, staticRenderFns } from "./percent-bar.html?vue&type=template&id=6776a084&scoped=true&"
import script from "./percent-bar.js?vue&type=script&lang=js&"
export * from "./percent-bar.js?vue&type=script&lang=js&"
import style0 from "./percent-bar.scss?vue&type=style&index=0&id=6776a084&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6776a084",
  null
  
)

export default component.exports